module.exports = {
  'en': {
    'HRES4AXC1': {
      '10': 'Company',
      '20': 'Function Line',
      '30': 'Created Date',
      '40': 'Simulate By',
      '50': 'Function Line Name',
      '60': 'Used Date',
      '70': 'Status'
    },
    'HRES4AXC4': {
      '10': 'List of Employee',
      '20': 'Company',
      '30': 'Function Line',
      '40': 'Simulation Date',
      '50': 'Department',
      '60': 'Position',
      '61': 'List of Current employee',
      '65': 'Othes Data',
      '70': 'Emp.ID',
      '80': 'Name',
      '90': 'Position Status',
      '100': 'Level',
      '110': 'Hire Date',
      '120': 'Type of Employee',
      '200': 'List subordinates',
      '210': 'Emp.ID',
      '220': 'Name',
      '230': 'Department',
      '240': 'Position',
      '250': 'Level',
      '260': 'Hire Date',
      '270': 'Position detail',
      '300': 'List of successor',
      '310': 'Seq.',
      '320': 'Emp.ID',
      '330': 'Name',
      '340': 'Department',
      '350': 'Position',
      '360': 'Level',
      '370': 'Hire Date'
    },
    'STDPOSP1': {
      '20': 'Position detail',
      '30': 'Position detail',
      '40': 'Department',
      '50': 'Position',
      '60': 'Position initials',
      '70': 'Employee level',
      '80': 'Job Code',
      '90': 'Remark',
      '100': 'Job Grade',
      '110': 'Job Group'
    },
    'STDPOSP2': {
      '10': 'KPI',
      '20': 'KPI level',
      '30': 'KPI detail',
      '40': 'Target assigned'
    },
    'STDPOSP3': {
      '10': 'Competency',
      '20': 'Type of',
      '30': 'competency',
      '40': 'detail',
      '50': 'Code of',
      '60': 'competency',
      '70': 'detail',
      '80': 'full score',
      '90': 'expected level',
      '100': 'Type of Competency',
      '110': 'Code of Competency'
    }
  },
  'th': {
    'HRES4AXC1': {
      '10': 'บริษัท',
      '20': 'สายงาน',
      '30': 'วันที่ทดลอง',
      '40': 'ผู้ทดลอง',
      '50': 'ชื่อสายงาน',
      '60': 'วันที่มีผลบังคับใช้',
      '70': 'สถานะ'
    },
    'HRES4AXC4': {
      '10': 'รายชื่อพนักงาน',
      '20': 'บริษัท',
      '30': 'สายงาน',
      '40': 'วันที่ทดลองปรับ',
      '50': 'หน่วยงาน',
      '60': 'ตำแหน่ง',
      '61': 'รายชื่อพนักงานที่ดำรงตำแหน่งปัจจุบัน',
      '65': 'รายละเอียดอื่นๆ',
      '70': 'รหัสพนักงาน',
      '80': 'ชื่อ',
      '90': 'สถานะตำแหน่ง',
      '100': 'ระดับ',
      '110': 'วันที่เริ่มงาน',
      '120': 'ประเภทพนักงาน',
      '200': 'รายชื่อผู้ใต้บังคับบัญชา',
      '210': 'รหัสพนักงาน',
      '220': 'ชื่อ',
      '230': 'หน่วยงาน',
      '240': 'ตำแหน่ง',
      '250': 'ระดับ',
      '260': 'วันที่เริ่มงาน',
      '270': 'รายละเอียดตำแหน่งงาน',
      '300': 'List of successor',
      '310': 'ลำดับที่',
      '320': 'รหัสพนักงาน',
      '330': 'ชื่อ',
      '340': 'หน่วยงาน',
      '350': 'ตำแหน่ง',
      '360': 'ระดับ',
      '370': 'วันที่เริ่มงาน'
    },
    'STDPOSP1': {
      '20': 'รายละเอียดตำแหน่ง',
      '30': 'รายละเอียดตำแหน่ง',
      '40': 'หน่วยงาน',
      '50': 'ตำแหน่ง',
      '60': 'ชื่อย่อตำแหน่ง',
      '70': 'ระดับพนักงาน',
      '80': 'Job Code',
      '90': 'หมายเหตุ',
      '100': 'Job Grade',
      '110': 'Job Group'
    },
    'STDPOSP2': {
      '10': 'KPI',
      '20': 'ลำดับ KPI',
      '30': 'รายละเอียด KPI',
      '40': 'เป้าหมายที่กำหนด'
    },
    'STDPOSP3': {
      '10': 'Competency',
      '20': 'ประเภท',
      '30': 'ความสามารถ',
      '40': 'รายละเอียด',
      '50': 'รหัสความ',
      '60': 'สามารถ',
      '70': 'รายละเอียด',
      '80': 'คะแนนเต็ม',
      '90': 'คะแนนที่ดาดหวัง',
      '100': 'ประเภทความสามารถ',
      '110': 'รหัสความสามารถ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres4ax.js